import { graphql } from "gql";

const INTERNAL_ADMIN_CREATE_USER_ATTRIBUTE_CATEGORY_MUTATION = graphql(`
  mutation InternalAdminCreateUserAttributeCategory(
    $organizationId: ID!
    $input: AdminCreateUserAttributeCategoryInput!
  ) {
    internalAdminCreateUserAttributeCategory(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminUserAttributeCategory
    }
  }
`);

export default INTERNAL_ADMIN_CREATE_USER_ATTRIBUTE_CATEGORY_MUTATION;
